import { TableCell, styled } from "@mui/material";

export const StyledTableCell = styled(TableCell, {
    shouldForwardProp: (props) => !["active"].includes(props)
})(({ active, theme }) => ({
    textWrap: "nowrap",
    ".MuiTableSortLabel-icon, .Mui-active": {
        color: `${theme.palette.hubColors.mainFocus} !important`,
    }
}))